import { API_IMAGE_CONTEXT } from "constants/api";

export const CHAPTER_5_CONTENTS = [
  {
    title: "이번 주 우리 아기는?",
    subtitle: "주수별로 달라지는 아기 성장",
    src: `${API_IMAGE_CONTEXT}/front/pregnancyRevealReport/ic_quick_calendar_solid.png`,
  },
  {
    title: "우리 아기 초음파 사진 자동 분석",
    subtitle: "초음파 사진 자동 분석",
    src: `${API_IMAGE_CONTEXT}/front/pregnancyRevealReport/ic_quick_fetus_solid.png`,
  },
  {
    title: "5가지 태아 성장 수치를 통해 잘 크고 있는지 확인",
    subtitle: "태아성장보고서",
    src: `${API_IMAGE_CONTEXT}/front/pregnancyRevealReport/ic_quick_report_solid.png`,
  },
  {
    title: "같은 주수, 일수 태아들과 성장을 비교해보세요.",
    subtitle: "성장속도 비교분석",
    src: `${API_IMAGE_CONTEXT}/front/pregnancyRevealReport/ic_quick_growth_solid.png`,
  },
  {
    title: "임신부터 산후까지 이어지는 체중 관리",
    subtitle: "산모체중관리",
    src: `${API_IMAGE_CONTEXT}/front/pregnancyRevealReport/ic_quick_bmi_solid.png`,
  },
];

export const CATEGORY_LIST = [
  {
    ctIcon: `${API_IMAGE_CONTEXT}/front/pregnancyRevealReport/ic_quick_report_solid.png`,
    ctNm: "태아성장보고서",
  },
  {
    ctIcon: `${API_IMAGE_CONTEXT}/front/pregnancyRevealReport/ic_quick_bmi_solid.png`,
    ctNm: "산모체중관리",
  },
  {
    ctIcon: `${API_IMAGE_CONTEXT}/front/pregnancyRevealReport/ic_quick_gcreport_solid.png`,
    ctNm: "The Growth Class",
  },
  {
    ctIcon: `${API_IMAGE_CONTEXT}/front/pregnancyRevealReport/ic_quick_calendar_solid.png`,
    ctNm: "다이어리",
  },
  {
    ctIcon: `${API_IMAGE_CONTEXT}/front/pregnancyRevealReport/ic_quick_fetus.png`,
    ctNm: "이번 주 태아상태",
  },
  {
    ctIcon: `${API_IMAGE_CONTEXT}/front/pregnancyRevealReport/ic_quick_more_solid.png`,
    ctNm: "모아보기",
  },
];
